module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payment_method":"Payment","add_card":"Add card"},"th":{"payment_method":"วิธีการชำระเงิน","add_card":"เพิ่มบัตร"}}')
  delete Component.options._Ctor
}
